import React, { Fragment } from 'react';
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { connect } from "react-redux";
import Common from '../Common';
import Stripe from './Payment/index';

class Payment extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount = async () => {

    };


    render() {
    
        return (
            <Fragment>
                <Common 
                    title={"Stripe Integration"} 
                    titleContent={
                        <span>Stripe Integration</span>
                    } 
                    mainContent={
                        <Stripe setSubCurrency={this.props.processCurrency}/>
                    } 
                />
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payment);